const states = {
  isOpenTag: true,           // 是否打开tab标签
  clickTabIdx: 0,            // 选择年级tab标签下标
  addToCartInfo: {},         // 点击添加购物车信息
  shoppingCount: 0,          // 购物车数量
  curCourseList: [],         // 当前展示课程列表
  selectedName: '',          // 选择的tab名称
  shoppingCartListIds: []    // 已加入购物车列表商品id
};
export default states;
